import { render, staticRenderFns } from "./ButtonSend.vue?vue&type=template&id=65187a43&"
import script from "./ButtonSend.vue?vue&type=script&lang=ts&"
export * from "./ButtonSend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports